import React from "react";
import { Link } from "react-router-dom";
import { MINIO_URL } from "../config";

function GameCard({ game }) {
    return (
        <Link to={`/game/${game.id}`} className="group block bg-gradient-to-br from-[#021428] to-[#011428] rounded-xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition">
            <div className="w-full h-64 bg-gray-800 overflow-hidden">
                <img src={`${MINIO_URL}${game.id}/${game.thumb}`} alt={game.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div className="p-3">
                <div className="font-semibold text-white">{game.name}</div>
                <div className="text-xs text-blue-200 mt-1">{game.category}</div>
            </div>
        </Link>
    );
}
export default GameCard;